export const Feature = {
  /**
   * Access to range warnings and alerts.
   */
  Range: 'range',
}
